WiseMetering.Views.NewContract = WiseMetering.Views.Modal.Save.extend({
    form_prefix: 'contract',
    template: 'templates/contracts/new',
    title: () => i18next.t('modal.title.contracts.new'),
    ui: {
        extra: '#contract-extra',
        finish: '#contract-finish',
        start: '#contract-start',
        tariff: '#contract-tariff'
    },
    events: {
        'change @ui.start': 'onChangeStart',
        'change @ui.tariff': 'onTariffChange'
    },

    getFormData: function() {
        const data = this.formSerializer();
        if (data.extra) {
            Object.entries(data.extra).map(([key, value]) => {
                data.extra[key] = value * 1000;
            });
        }
        return data;
    },

    onChangeStart: function() {
        this.ui.start.attr('disabled', true);
        this.ui.finish.attr('disabled', false).attr('min', this.ui.start.val());
    },

    onRender: function() {
        const countryCode = this.options.utility.site().get('address').country_code;
        const utilityKindSlug = this.options.utility.utilityKind().get('slug');

        this.renderTariffs(countryCode, utilityKindSlug);
        this.setupDates();
        this.renderExtra();
    },

    onTariffChange: function() {
        this.renderExtra();
    },

    renderExtra: function() {
        const tariff = WiseMetering.tariffs.get(this.ui.tariff.val());
        const extraTemplate = tariff?.extraTemplate();

        if (extraTemplate) {
            this.ui.extra.html(JST[`templates/contracts/extra/${extraTemplate}`]());
        } else {
            this.ui.extra.empty();
        }
    },

    renderTariffs: function(countryCode, utilityKindSlug) {
        const tariffs = WiseMetering.tariffs.where({ country_code: countryCode, utility_kind_slug: utilityKindSlug });
        this.ui.tariff.html(WiseMetering.utils.optionsFromModels(tariffs));
    },

    setupDates: function() {
        const minDate = this.options.utility.nextAvailableDate();

        if (this.options.utility.contracts().length === 0) {
            this.ui.start.attr('min', minDate);
            this.ui.finish.attr('disabled', true);
        } else {
            this.ui.start.attr('disabled', true).val(minDate);
            this.ui.finish.attr('min', minDate);
        }
    }
});
